module.exports = __webpack_public_path__ + "img/Abnormal_MB_LWN.bc3be214.png";